import React, {
  FC, useEffect, useState,
} from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
  BackgroundImage,
} from './Styles';
import Header from '../../../../Common/Header';
import { Cab } from '../../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../../../Common/Logo';
import { Button } from '../../../../Common/Header/Styles';

const OfflineOpenBox: FC<Props> = ({
  cabId32Str,
  cab,
  userId,
  pickupCode,
  pickupRoomNo,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  setTargetPage,
}) => {
  const [saveCallLog] = updateFoodifoxData('/foxH5RentLog/saveCallServiceLog');
  const [getQrCodeLazy] = getFoodifoxDataLazy<{ qrCode: string; boxNumber: string; }[]>('/foxH5OfflineQrCode/getQrCodeText');
  const [boxAndCodes, setBoxAndCodes] = useState<{ qrCode: string; boxNumber: string; }[]>([]);

  useEffect(() => {
    setShowLoading(true);
    getQrCodeLazy({
      param: {
        cabId: cab.cabId,
        userId,
        openCode: pickupCode,
        roomNo: pickupRoomNo,
      },
      onError() {
        setShowLoading(false);
      },
      onCompleted(data) {
        setShowLoading(false);
        setBoxAndCodes(data);
      },
    });
  }, []);

  return (
    <BackgroundImage>
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
      />

      <Logo
        style={{ marginTop: '30px' }}
        showBackIcon={false}
      />

      {
        isEnglish ? (
          <>
            <div
              style={{
                fontSize: '14px',
                fontFamily: 'Squad-Regular, Squad',
                fontWeight: 400,
                color: '#11202B',
                lineHeight: '20px',
                width: '260px',
                textAlign: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '20px',
              }}
            >
              Sorry, the locker is unresponding. Please use the scanner on the locker to
              <br />
              <span style={{ fontSize: '14px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '20px' }}>
                scan the following QR code
              </span>
              !
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                fontSize: '14px',
                fontFamily: 'PingFangSC-Regular, PingFang SC',
                fontWeight: 400,
                color: '#11202B',
                lineHeight: '20px',
                textAlign: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '20px',
              }}
            >
              抱歉，柜子目前无响应。请使用柜子上的扫码器
              <br />
              <span style={{ fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600 }}>
                扫描下方二维码开柜。
              </span>
            </div>
          </>
        )
      }

      {
        boxAndCodes && (
          <div
            style={{
              width: '260px',
              textAlign: 'center',
              marginTop: '20px',
              marginLeft: 'auto',
              marginRight: 'auto',
              borderRadius: '15px',
              border: '1px solid rgba(17,32,43,0.1)',
              backgroundColor: '#FFFFFF',
            }}
          >
            {
              boxAndCodes.map(({ qrCode, boxNumber }, index) => (
                <>
                  {
                    index > 0 && (
                      <div style={{ width: '190px', height: '1px', background: '#D8D8D8', marginLeft: 'auto', marginRight: 'auto' }} />
                    )
                  }
                  {/* 柜门信息 */}
                  {
                    isEnglish ? (
                      <div style={{ marginTop: '18px', fontSize: '18px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '24px' }}>
                        Door #{boxNumber}
                      </div>
                    ) : (
                      <div style={{ marginTop: '18px', fontSize: '18px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B', lineHeight: '25px' }}>
                        柜门编号 #{boxNumber}
                      </div>
                    )
                  }
                  <QRCodeSVG
                    key={qrCode}
                    level={'H'}
                    value={qrCode}
                    width={190}
                    height={190}
                    style={{ marginTop: '12px', marginBottom: '20px' }}
                  />
                </>
              ))
            }

            <div style={{ marginTop: '10px', fontSize: '14px', fontFamily: isEnglish ? 'Squad-Regular, Squad' : 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '18px' }}>
              {
                isEnglish ? (
                  <>
                    If the QR code doesn’t work,  Please
                    <br />
                    contact us by calling
                  </>
                ) : (
                  <div style={{ marginBottom: '7px' }}>如果扫描二维码仍旧无法打开柜门，<br />请致电人工服务</div>
                )
              }
              <div style={{ fontSize: '14px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B', lineHeight: '18px' }}>
                1300 359 889
              </div>
            </div>

            <Button
              onClick={() => {
                location.href = 'tel:1300359889';
                saveCallLog({
                  param: {
                    cabId: cabId32Str,
                    telNumber: '1300359889',
                  },
                });
              }}
              style={{
                width: '111px',
                height: '38px',
                background: '#11202B',
                borderRadius: '27px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignSelf: 'center',
                alignItems: 'center',
                fontSize: '14px',
                fontFamily: 'PingFangSC-SemiBold, PingFang SC',
                fontWeight: 600,
                color: '#FFFFFF',
                lineHeight: '18px',
                margin: '30px auto 20px auto',
              }}
            >
              {
                isEnglish ? (
                  <>Call now</>
                ) : (
                  <>立即拨打</>
                )
              }
            </Button>
          </div>
        )
      }

      <div style={{ height: '50px', width: '100%' }} />
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  cab: Cab;
  userId: number;
  pickupCode?: string;
  pickupRoomNo?: string;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  setTargetPage: (targetPage: string) => void;
}

export default OfflineOpenBox;
